import { QueryClient } from '@tanstack/react-query';

export const tanstackQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      notifyOnChangeProps: 'all',
      refetchOnWindowFocus: false,
    },
  },
});
